import { post } from "../Services/http";
import { catchError } from "./Error.action";

export const HECO_CUSTOMER_APPLICATION_FORM_UPDATE = 'HECO_CUSTOMER_APPLICATION_FORM_UPDATE';
export const HECO_CUSTOMER_APPLICATION_FORM_ERROR = 'HECO_CUSTOMER_APPLICATION_FORM_ERROR';

export const updateCustomerApplicationForm = (customerApplication) => ({
    type: HECO_CUSTOMER_APPLICATION_FORM_UPDATE,
    payload: {
        customerApplication,
    },
});

export const setCustomerApplicationFormError = (error) => ({
    type: HECO_CUSTOMER_APPLICATION_FORM_ERROR,
    payload: {
        error,
    },
});

export const submitCustomerApplicationForm = (customerApplication) => (dispatch) => {
    // console.log('Submit customer application', customerApplication)
    post('/api/customer-application/submit', customerApplication)
        .then(() => dispatch(updateCustomerApplicationForm({
            ...customerApplication,
            submitted: true
        })))
        .catch((ex) => dispatch(catchError(ex, (error) => setCustomerApplicationFormError(error))));
}

